import {ReactNode, useEffect, useRef, useState} from "react";

import styles from './Info.module.scss'

export default ({children, forceDisplay}: {children: ReactNode, forceDisplay?: boolean}) => {


  const [horPosition, setHorPosition] = useState<"left" | "right">("left");
  const [vertPosition, setVertPosition] = useState<"top" | "bottom">("top");
  const iconRef = useRef<HTMLElement>(null);
  const popupRef = useRef<HTMLSpanElement>(null);


  useEffect(() => {
    const adjustPopupPosition = () => {
      if (popupRef.current && iconRef.current) {
        const iconRect = iconRef.current.getBoundingClientRect();
        const rect = popupRef.current.getBoundingClientRect();

        if (iconRect.right + rect.width > window.innerWidth) {
          setHorPosition("right"); // Verplaats popup naar links
        } else {
          setHorPosition("left"); // Houd popup rechts
        }
        if (iconRect.top - rect.height < 0) {
          setVertPosition("bottom");
        } else {
          setVertPosition("top");
        }
      }
    };

    // Controleer de positie bij het laden en resize
    adjustPopupPosition();
    window.addEventListener("resize", adjustPopupPosition);
    window.addEventListener("scroll", adjustPopupPosition);

    return () => {
      window.removeEventListener("resize", adjustPopupPosition);
      window.removeEventListener("scroll", adjustPopupPosition);
    };
  }, []);

  return <i
    className={`fa-solid fa-circle-info ${styles.icon}`}
    ref={iconRef}
  >
    <span ref={popupRef} className={[
      styles.info,
      horPosition === "right" ? styles.infoRight : null,
      vertPosition === "bottom" ? styles.infoBottom : null,
      forceDisplay ? styles.forceDisplay : null,
    ].join(' ')}>{children}</span>
  </i>
}